// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"817":"8a9e2d9008a4a7c8","927":"3b7da7d45c3feef7","2231":"d6cd38f12ce24575","3741":"5f302390b6dff356","5309":"00d45f258f04c0df","6874":"09eca943314936d0","7347":"1b69d284e6ddc67d","8058":"b4154f62321ed511","8231":"f445c322d4c8e422"}[chunkId] + ".js";
};